import _ from 'lodash'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { Slot as ScheduleSlot, WorkingHours } from '@/core/models/schedule.model'

dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)
dayjs.extend(utc)
dayjs.extend(timezone)

type Slot = Pick<ScheduleSlot, 'start' | 'end'>

function checkIfSlotIsInBusy(slot: Slot, busySlots: Slot[]): boolean {
  return busySlots.some((busySlot) => {
    return dayjs(slot.start).isSame(dayjs(busySlot.start)) || dayjs(busySlot.end).isBetween(dayjs(slot.start), dayjs(slot.end))
  })
}

export function generateSlots(day: Date, workingHours: WorkingHours[], busy: Slot[], duration: number, timeZone?: string): Slot[] {
  let slots = []

  const dayOfWeek = dayjs(day).day()

  for (const workingHour of workingHours) {
    const slotDuration = workingHour.duration ?? duration
    if (!workingHour.days.includes(dayOfWeek) || !slotDuration) continue

    const numberSlots = (workingHour.endTime - workingHour.startTime) / slotDuration

    for (let i = 0; i < numberSlots; i++) {
      const start = dayjs(day)
        .startOf('day')
        .add(workingHour.startTime + i * slotDuration, 'minute')
      const slot = {
        start: start.toISOString(),
        end: start.clone().add(slotDuration, 'minute').toISOString(),
      }
      if (checkIfSlotIsInBusy(slot, busy) === false && dayjs(slot.start).isSameOrAfter(dayjs())) {
        slots.push(slot)
      }
    }
  }

  slots.sort((slotA, slotB) => {
    const slotAStart = new Date(slotA.start)
    const slotAEnd = new Date(slotA.end)
    const slotBStart = new Date(slotB.start)
    const slotBEnd = new Date(slotB.end)
    const compared = slotAStart.getTime() - slotBStart.getTime()
    return compared === 0 ? slotAEnd.getTime() - slotBEnd.getTime() : compared
  })

  slots = _.uniqWith(slots, (slotA, slotB) => slotA.start === slotB.start)

  return slots
}
